/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CompanySaveconsultantsorderPostRequest } from '../models';
// @ts-ignore
import { Customer } from '../models';
// @ts-ignore
import { DamageCase } from '../models';
// @ts-ignore
import { Person } from '../models';
/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all customers
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersGet: async (offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific customer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersIdGet', 'id', id)
            const localVarPath = `/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all consultants and customers
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdGetconsultantsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersIdGetconsultantsGet', 'id', id)
            const localVarPath = `/customers/{id}/getconsultants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a processes of specefic customer
         * @param {number} id 
         * @param {number} [vehicleId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdProcessesGet: async (id: number, vehicleId?: number, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersIdProcessesGet', 'id', id)
            const localVarPath = `/customers/{id}/processes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (vehicleId !== undefined) {
                localVarQueryParameter['vehicleId'] = vehicleId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific customer
         * @param {number} id 
         * @param {Customer} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdPut: async (id: number, customer?: Customer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersIdPut', 'id', id)
            const localVarPath = `/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save consultants for customer
         * @param {number} id 
         * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdSaveconsultantsorderPost: async (id: number, companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customersIdSaveconsultantsorderPost', 'id', id)
            // verify required parameter 'companySaveconsultantsorderPostRequest' is not null or undefined
            assertParamExists('customersIdSaveconsultantsorderPost', 'companySaveconsultantsorderPostRequest', companySaveconsultantsorderPostRequest)
            const localVarPath = `/customers/{id}/saveconsultantsorder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companySaveconsultantsorderPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new customer
         * @param {Customer} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPost: async (customer?: Customer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all customers
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
         * @param {string} [searchvalue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementCustomersGet: async (page?: number, perPage?: number, sort?: string, searchvalue?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/management/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (searchvalue !== undefined) {
                localVarQueryParameter['searchvalue'] = searchvalue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all customers
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersGet(offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Customer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersGet(offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific customer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all consultants and customers
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersIdGetconsultantsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersIdGetconsultantsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a processes of specefic customer
         * @param {number} id 
         * @param {number} [vehicleId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersIdProcessesGet(id: number, vehicleId?: number, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersIdProcessesGet(id, vehicleId, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific customer
         * @param {number} id 
         * @param {Customer} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersIdPut(id: number, customer?: Customer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersIdPut(id, customer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Save consultants for customer
         * @param {number} id 
         * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersIdSaveconsultantsorderPost(id: number, companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersIdSaveconsultantsorderPost(id, companySaveconsultantsorderPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new customer
         * @param {Customer} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersPost(customer?: Customer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersPost(customer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all customers
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
         * @param {string} [searchvalue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementCustomersGet(page?: number, perPage?: number, sort?: string, searchvalue?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Customer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementCustomersGet(page, perPage, sort, searchvalue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * Get all customers
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersGet(offset?: number, size?: number, options?: any): AxiosPromise<Array<Customer>> {
            return localVarFp.customersGet(offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific customer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdGet(id: number, options?: any): AxiosPromise<Customer> {
            return localVarFp.customersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all consultants and customers
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdGetconsultantsGet(id: number, options?: any): AxiosPromise<Person> {
            return localVarFp.customersIdGetconsultantsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a processes of specefic customer
         * @param {number} id 
         * @param {number} [vehicleId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdProcessesGet(id: number, vehicleId?: number, type?: string, options?: any): AxiosPromise<DamageCase> {
            return localVarFp.customersIdProcessesGet(id, vehicleId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific customer
         * @param {number} id 
         * @param {Customer} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdPut(id: number, customer?: Customer, options?: any): AxiosPromise<Customer> {
            return localVarFp.customersIdPut(id, customer, options).then((request) => request(axios, basePath));
        },
        /**
         * Save consultants for customer
         * @param {number} id 
         * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersIdSaveconsultantsorderPost(id: number, companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.customersIdSaveconsultantsorderPost(id, companySaveconsultantsorderPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new customer
         * @param {Customer} [customer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersPost(customer?: Customer, options?: any): AxiosPromise<Customer> {
            return localVarFp.customersPost(customer, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all customers
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
         * @param {string} [searchvalue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementCustomersGet(page?: number, perPage?: number, sort?: string, searchvalue?: string, options?: any): AxiosPromise<Array<Customer>> {
            return localVarFp.managementCustomersGet(page, perPage, sort, searchvalue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * Get all customers
     * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersGet(offset?: number, size?: number, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersGet(offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific customer
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersIdGet(id: number, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all consultants and customers
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersIdGetconsultantsGet(id: number, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersIdGetconsultantsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a processes of specefic customer
     * @param {number} id 
     * @param {number} [vehicleId] 
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersIdProcessesGet(id: number, vehicleId?: number, type?: string, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersIdProcessesGet(id, vehicleId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific customer
     * @param {number} id 
     * @param {Customer} [customer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersIdPut(id: number, customer?: Customer, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersIdPut(id, customer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save consultants for customer
     * @param {number} id 
     * @param {CompanySaveconsultantsorderPostRequest} companySaveconsultantsorderPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersIdSaveconsultantsorderPost(id: number, companySaveconsultantsorderPostRequest: CompanySaveconsultantsorderPostRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersIdSaveconsultantsorderPost(id, companySaveconsultantsorderPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new customer
     * @param {Customer} [customer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public customersPost(customer?: Customer, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersPost(customer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all customers
     * @param {number} [page] Pagenumber
     * @param {number} [perPage] Items shown per page
     * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
     * @param {string} [searchvalue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public managementCustomersGet(page?: number, perPage?: number, sort?: string, searchvalue?: string, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).managementCustomersGet(page, perPage, sort, searchvalue, options).then((request) => request(this.axios, this.basePath));
    }
}
